(() => {
  'use strict';

  const TEMPLATE_SELECTOR = '#cart-drawer-upsell-template';
  const UPSELL_SELECTOR = '#cart-drawer-upsell';
  const CART_DRAWER_SELECTOR = '#CartDrawer';
  const CART_ITEMS_SELECTOR = '#CartDrawer-CartItems';
  const FOOTER_SELECTOR = '#CartDrawer > .drawer__inner > .drawer__footer';
  const ADD_FORM_SELECTOR =
    '#cart-drawer-upsell form.cart-drawer-upsell-form';

  let currentSlideIndex = Number(
    sessionStorage.getItem('virelleUpsellSlide') || 0
  );

  let refreshTimer = null;
  let isRefreshing = false;
  let isRendering = false;
  let isAddingProduct = false;

  function getCartAddUrl() {
    const root =
      window.Shopify?.routes?.root ||
      '/';

    return `${root}cart/add.js`;
  }

  function saveSlideIndex(index) {
    currentSlideIndex = Math.max(0, Number(index) || 0);

    sessionStorage.setItem(
      'virelleUpsellSlide',
      String(currentSlideIndex)
    );
  }

  function getSlides(list) {
    return Array.from(
      list.querySelectorAll(
        '.cart-drawer-upsell-list-item'
      )
    );
  }

  function getSectionsToRender(cartDrawer) {
    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function'
    ) {
      return cartDrawer
        .getSectionsToRender()
        .map((section) => section.id)
        .filter(Boolean);
    }

    return [
      'cart-drawer',
      'cart-icon-bubble'
    ];
  }

  function initializeSlider(section) {
    const list = section.querySelector(
      '.cart-drawer-upsell-list'
    );

    const previousButton = section.querySelector(
      '[data-upsell-previous]'
    );

    const nextButton = section.querySelector(
      '[data-upsell-next]'
    );

    if (!list || !previousButton || !nextButton) {
      return;
    }

    const slides = getSlides(list);

    if (!slides.length) {
      return;
    }

    currentSlideIndex = Math.min(
      currentSlideIndex,
      slides.length - 1
    );

    if (slides.length <= 1) {
      previousButton.hidden = true;
      nextButton.hidden = true;
    }

    function updateButtons() {
      previousButton.disabled =
        currentSlideIndex <= 0;

      nextButton.disabled =
        currentSlideIndex >= slides.length - 1;
    }

    function goToSlide(index, behavior = 'smooth') {
      const safeIndex = Math.max(
        0,
        Math.min(index, slides.length - 1)
      );

      const slide = slides[safeIndex];

      if (!slide) {
        return;
      }

      saveSlideIndex(safeIndex);
      updateButtons();

      list.scrollTo({
        left: slide.offsetLeft,
        behavior
      });
    }

    previousButton.addEventListener('click', () => {
      goToSlide(currentSlideIndex - 1);
    });

    nextButton.addEventListener('click', () => {
      goToSlide(currentSlideIndex + 1);
    });

    let scrollTimer = null;

    list.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);

        scrollTimer = window.setTimeout(() => {
          let nearestIndex = 0;
          let nearestDistance = Infinity;

          slides.forEach((slide, index) => {
            const distance = Math.abs(
              slide.offsetLeft - list.scrollLeft
            );

            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          saveSlideIndex(nearestIndex);
          updateButtons();
        }, 120);
      },
      {
        passive: true
      }
    );

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        goToSlide(currentSlideIndex, 'auto');
      });

      resizeObserver.observe(list);
    }

    requestAnimationFrame(() => {
      goToSlide(currentSlideIndex, 'auto');
    });
  }

  function renderCartDrawerUpsell() {
    const drawerContainer = document.querySelector(
      CART_DRAWER_SELECTOR
    );

    const template = document.querySelector(
      TEMPLATE_SELECTOR
    );

    if (
      !drawerContainer ||
      !template ||
      isRendering
    ) {
      return;
    }

    isRendering = true;

    try {
      const existingUpsell =
        drawerContainer.querySelector(
          UPSELL_SELECTOR
        );

      if (existingUpsell) {
        existingUpsell.remove();
      }

      const cartDrawerItems =
        drawerContainer.querySelector(
          'cart-drawer-items'
        );

      if (
        !cartDrawerItems ||
        cartDrawerItems.classList.contains('is-empty')
      ) {
        return;
      }

      const footer = document.querySelector(
        FOOTER_SELECTOR
      );

      if (!footer) {
        return;
      }

      const fragment =
        template.content.cloneNode(true);

      const newUpsell = fragment.querySelector(
        UPSELL_SELECTOR
      );

      if (
        !newUpsell ||
        !newUpsell.querySelector(
          '.cart-drawer-upsell-list-item'
        )
      ) {
        return;
      }

      /*
       * Plaats de upsell direct boven kortingscode,
       * totaal en checkout.
       */
      footer.prepend(newUpsell);

      initializeSlider(newUpsell);
    } finally {
      window.setTimeout(() => {
        isRendering = false;
      }, 0);
    }
  }

  function replaceRenderedSection(
    sectionHtml,
    selector
  ) {
    if (!sectionHtml) {
      return;
    }

    const parsedDocument =
      new DOMParser().parseFromString(
        sectionHtml,
        'text/html'
      );

    const newElement =
      parsedDocument.querySelector(selector);

    const currentElement =
      document.querySelector(selector);

    if (!newElement || !currentElement) {
      return;
    }

    currentElement.innerHTML =
      newElement.innerHTML;
  }

  function renderCartFallback(responseData) {
    if (!responseData.sections) {
      return;
    }

    replaceRenderedSection(
      responseData.sections['cart-drawer'],
      '#CartDrawer'
    );

    replaceRenderedSection(
      responseData.sections['cart-icon-bubble'],
      '#cart-icon-bubble'
    );

    const cartDrawer =
      document.querySelector('cart-drawer');

    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.add('active');
      }
    }
  }

  async function refreshUpsellTemplate() {
    if (isRefreshing) {
      return;
    }

    isRefreshing = true;

    try {
      const response = await fetch(
        window.location.href,
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          `Upsell refresh failed: ${response.status}`
        );
      }

      const html = await response.text();

      const newDocument =
        new DOMParser().parseFromString(
          html,
          'text/html'
        );

      const currentTemplate =
        document.querySelector(
          TEMPLATE_SELECTOR
        );

      const newTemplate =
        newDocument.querySelector(
          TEMPLATE_SELECTOR
        );

      if (currentTemplate && newTemplate) {
        currentTemplate.replaceWith(newTemplate);
      }

      renderCartDrawerUpsell();
    } catch (error) {
      console.error(
        'De cart-upsell kon niet worden vernieuwd.',
        error
      );
    } finally {
      isRefreshing = false;
    }
  }

  async function addUpsellProduct(form) {
    if (isAddingProduct) {
      return;
    }

    const addButton = form.querySelector(
      'button[name="add"]'
    );

    const cartDrawer =
      document.querySelector('cart-drawer');

    isAddingProduct = true;

    if (addButton) {
      addButton.disabled = true;
      addButton.classList.add('loading');
      addButton.setAttribute(
        'aria-disabled',
        'true'
      );
    }

    try {
      const formData = new FormData(form);

      /*
       * De upsell voegt altijd één product toe.
       */
      formData.set('quantity', '1');

      const sections =
        getSectionsToRender(cartDrawer);

      if (sections.length) {
        formData.set(
          'sections',
          sections.join(',')
        );
      }

      formData.set(
        'sections_url',
        window.location.pathname
      );

      const response = await fetch(
        getCartAddUrl(),
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        }
      );

      const responseData =
        await response.json();

      if (
        !response.ok ||
        responseData.status
      ) {
        const errorMessage =
          responseData.description ||
          responseData.message ||
          'Le produit ne peut pas être ajouté.';

        throw new Error(errorMessage);
      }

      /*
       * Gebruik de ingebouwde drawer-renderer
       * wanneer het theme die beschikbaar stelt.
       */
      if (
        cartDrawer &&
        typeof cartDrawer.renderContents === 'function'
      ) {
        cartDrawer.renderContents(responseData);
      } else {
        renderCartFallback(responseData);
      }

      /*
       * Vernieuw de upsellproducten. Het zojuist
       * toegevoegde product verdwijnt uit de upsell.
       */
      await refreshUpsellTemplate();

      const updatedDrawer =
        document.querySelector('cart-drawer');

      if (
        updatedDrawer &&
        typeof updatedDrawer.open === 'function'
      ) {
        updatedDrawer.open();
      }
    } catch (error) {
      console.error(
        'Upsellproduct toevoegen mislukt.',
        error
      );

      window.alert(
        error.message ||
        "Le produit n'a pas pu être ajouté."
      );
    } finally {
      isAddingProduct = false;

      /*
       * Bij een succesvolle toevoeging kan de knop al
       * vervangen zijn door de vernieuwde drawer.
       */
      if (addButton && addButton.isConnected) {
        addButton.disabled = false;
        addButton.classList.remove('loading');
        addButton.removeAttribute(
          'aria-disabled'
        );
      }
    }
  }

  /*
   * Capture phase voorkomt dat het normale
   * Shopify-formulier naar /cart navigeert.
   */
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (
        !(form instanceof HTMLFormElement) ||
        !form.matches(ADD_FORM_SELECTOR)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addUpsellProduct(form);
    },
    true
  );

  function mutationAffectsCartItems(mutation) {
    const target =
      mutation.target instanceof Element
        ? mutation.target
        : mutation.target.parentElement;

    if (!target) {
      return false;
    }

    if (
      target.closest(UPSELL_SELECTOR) ||
      target.closest(FOOTER_SELECTOR)
    ) {
      return false;
    }

    if (
      target.matches(CART_ITEMS_SELECTOR) ||
      target.closest(CART_ITEMS_SELECTOR)
    ) {
      return true;
    }

    return Array.from(
      mutation.addedNodes
    ).some((node) => {
      if (!(node instanceof Element)) {
        return false;
      }

      return (
        node.matches(CART_ITEMS_SELECTOR) ||
        Boolean(
          node.querySelector(
            CART_ITEMS_SELECTOR
          )
        )
      );
    });
  }

  function observeCartDrawer() {
    const cartDrawer =
      document.querySelector('cart-drawer');

    if (!cartDrawer) {
      return;
    }

    const observer =
      new MutationObserver((mutations) => {
        if (
          isRendering ||
          isRefreshing ||
          isAddingProduct
        ) {
          return;
        }

        const cartChanged =
          mutations.some(
            mutationAffectsCartItems
          );

        if (!cartChanged) {
          return;
        }

        window.clearTimeout(refreshTimer);

        refreshTimer = window.setTimeout(() => {
          refreshUpsellTemplate();
        }, 300);
      });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  window.onChangeKsUpsellVariantSelector =
    function (select) {
      const selectedOption =
        select.options[select.selectedIndex];

      const card = select.closest(
        '.cart-drawer-upsell-list-item'
      );

      if (!selectedOption || !card) {
        return;
      }

      const image = card.querySelector(
        '.cart-drawer-upsell-image'
      );

      const price = card.querySelector(
        '.cart-drawer-upsell-price'
      );

      const comparePrice = card.querySelector(
        '.cart-drawer-upsell-compare-price'
      );

      const imageSource =
        selectedOption.dataset.variantImg;

      const formattedPrice =
        selectedOption.dataset.price;

      const formattedComparePrice =
        selectedOption.dataset.comparePrice;

      if (image && imageSource) {
        image.src = imageSource;
      }

      if (price && formattedPrice) {
        price.textContent = formattedPrice;
      }

      if (comparePrice) {
        if (formattedComparePrice) {
          comparePrice.textContent =
            formattedComparePrice;

          comparePrice.hidden = false;
        } else {
          comparePrice.textContent = '';
          comparePrice.hidden = true;
        }
      }
    };

  function initialize() {
    renderCartDrawerUpsell();
    observeCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }
})();